define('gameday-index-gdtracking/src/BlueKai',['require','exports','module'],function(require,exports,module){
    var cachedObj = {};

    function BlueKaiPage(tracking){
        var s = tracking.omniture;
        this.bkMLBID = (typeof s.prop22!="undefined"?s.prop22:"");
        this.bkSiteName = "mlb" || "";
        this.bkChannel = (typeof s.channel!="undefined"?s.channel:"");
        this.bkCurrencyCode = (typeof s.currencyCode!="undefined"?s.currencyCode:"");
        this.bkPageName     = (typeof s.pageName!="undefined"?s.pageName:"");
        this.bkPageID = "Gameday";
        this.bkLang = "en" || "";          
        this.team1  = tracking.team1;
        this.team2  = tracking.team2;
        this.id = (tracking.device.site_formFactor === 'desktop') ? "14633" : "14634";        
    }

    BlueKaiPage.prototype = {
        fire: function() {            
        	bk_addPageCtx("mlbid", this.bkMLBID);
            bk_addPageCtx("sitename", this.bkSiteName);
            bk_addPageCtx("pagename", this.bkPageName);
            bk_addPageCtx("cur", this.bkCurrencyCode);
            bk_addPageCtx("chan", this.bkChannel);
            bk_addPageCtx("pageid", this.bkPageID);
            bk_addPageCtx("lang", this.bkLang);
            bk_addPageCtx("team1", this.team1);
            bk_addPageCtx("team2", this.team2);
        	BKTAG.doTag(this.id, 10);
        }
    };

    return BlueKaiPage
}); 

